<template>
    <div class="imageDrawer">
        <div class="imageDrawer-hd" @click="$emit('toggle-drawer', index)">
            <button type="button" :aria-label="getAriaLabelForEnlargeButton(item.heading)" class="imageDrawer-hd-trigger">
                <img :src="item.thumbnail" :alt="item.ThumbnailAltText" />
            </button>
            <div v-if="previewText" :class="['imageDrawer-hd-preview', drawerIsActive() ? 'isActive' : '']">
                <div class="hdg m-ellipsis">{{item.heading}}</div>
                <span class="m-ellipsis">{{item.text | truncate(30, '...')}}</span>
            </div>
        </div>
        <div :class="['imageDrawer-drawer', drawerIsActive() ? 'isActive' : '']" :ref="STRINGS.DRAWER + index" :style="`width: ${parentDimensions.containerWidth}; transition: ${ drawerIsActive() ? drawerAnimation : drawerCloseAnimation}; height: ${drawerIsActive() ? getDrawerHeight(): '0'}; left: ${drawerIsActive() ? getDrawerLeft() : doNothing()}; position: ${drawerIsActive() ? drawerPosition = 'relative': doNothing()};`">
            <div class="imageDrawer-drawer-container" :ref="STRINGS.DRAWER_CONTAINER">
                <div class="imageDrawer-drawer-container-content">
                    <div class="mediaBlock">
                        <div class="mediaBlock-media">
                            <img :src="item.mainImage" :alt="item.MainImageAltText" />
                        </div>
                        <div class="mediaBlock-copy mediaBlock-copy_verticalCenter">
                            <div class="mediaBlock-copy-close">
                                <button type="button" :aria-label="getAriaLabelForCloseButton(item.heading)" @click="$emit('toggle-drawer', index, {closeOnly: true})"><span class="isVisuallyHidden">Close</span><div class="icon icon_closingX icon_closingX_dark"></div></button>
                            </div>
                            <div class="richTextCard">
                                <div class="richTextCard-hdg">
                                    <h3 class="hdg hdg_3">{{item.heading}}</h3>
                                </div>
                                <div class="richTextCard-richtext">
                                    <div class="quarantineContent">
                                        {{item.text}}
                                    </div>
                                </div>
                                <a :href="item.linkPath" :aria-label="item.linkText" class="iconCta" :target="item.newWindow ? '_blank' : ''" v-if="item.linkPath">
                                    <div class="iconCta-text">
                                        {{item.linkText}}
                                    </div>
                                    <div class="iconCta-icon">
                                        <i class="icon icon_chevron"></i>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['item', 'previewText', 'index', 'activeItem', 'parentDimensions'],
        data() {
            return {
                containerOffsetLeft: null,
                drawerAnimation: 'height 1s ease, opacity 1s ease, margin 1s ease;',
                drawerCloseAnimation: 'height 1s ease, opacity 1s ease, margin 1s ease, left 2s cubic-bezier(1, 0, 0, 1);',
                STRINGS: {
                    DRAWER: 'drawer_',
                    DRAWER_CONTAINER: 'drawerInner',
                },
                leftDrawerValue: '0',
                drawerPosition: 'static',
            }
        },
        methods: {
            drawerIsActive() {
                ;
                if ((this.activeItem == this.index) == true) {
                    this.resetDrawer();
                    return true;
                }
                if ((this.activeItem == this.index) == false || (this.activeItem == this.index) == null) {
                    return false;
                }
            },
            resetDrawer(index) {
                this.$refs[this.STRINGS.DRAWER + this.index].style.left = 0;
                this.$refs[this.STRINGS.DRAWER + this.index].style.position = 'static';
            },
            getDrawerHeight() {
                return this.$refs[this.STRINGS.DRAWER_CONTAINER].scrollHeight + 'px';
            },
            getDrawerLeft() {
                const leftValue = this.$refs[this.STRINGS.DRAWER_CONTAINER].offsetLeft - this.parentDimensions.containerOffsetLeft
                return this.leftDrawerValue = `-${leftValue - 1}px`;
            },
            doNothing() {
                return;
            },
            getAriaLabelForEnlargeButton(input) {
                return "display " + input + " information segment";
            },
            getAriaLabelForCloseButton(input) {
                return "close " + input + " information segment";
            }
        }

    };
</script>